// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3992":"eda47a45","6047":"80ee3efe","6334":"8dea8de7","7050":"0d566a5d"}[chunkId] + ".chunk.css";
};